import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { ElMessageBox, ElMessage } from 'element-plus'
import { getToken, saveRefreshtime, getTokenRefreshTime } from '@/utils/auth'
import { sign, GetRandomString } from '@/utils/scm'

import defaultSettings from '@/settings'

// 是否显示重新登录
export let isRelogin = { show: false };
// create an axios instance
const service = axios.create({
  baseURL: defaultSettings.apiHostUrl,
  timeout: 10000 // request timeout
})

service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// request拦截器
service.interceptors.request.use(
  config => {
    if (config.headers['Content-Type'] === undefined) { config.headers['Content-Type'] = 'application/json;charset=UTF-8' }
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // 如果接口需要签名, 则通过请求时,headers中传递sign参数true
    const iSSign = config.headers['sign']
    if (iSSign || iSSign === undefined) {
      const timeStamp = new Date().getTime().toString().substring(0, 10)
      const nonce = GetRandomString()
      config.headers['appId'] = store.getters.appId
      config.headers['nonce'] = nonce
      config.headers['timeStamp'] = timeStamp
      config.headers['signature'] = sign(config, nonce, timeStamp, store.getters.appSecret)
    }
    saveRefreshtime()
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)
// response响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.ErrCode !== '0') {
      if (res.ErrCode === '401') {
        // token过期自动刷新token
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(getTokenRefreshTime))
        // 在用户操作的活跃期内
        if (getTokenRefreshTime && (curTime <= refreshtime)) {
          store.dispatch('ResetToken').then((res) => {
            location.reload()
          })
        }
        else {
          setLogOut()
        }
      } else if (res.ErrCode === '403') {
        router.push({
          path: '/403',
          query: {
            redirect: router.currentRoute.fullPath
          }
        }).catch(() => { })
      } else if (res.ErrCode === '40000' || res.ErrCode === '40008') {
        if (!isRelogin.show) {
          isRelogin.show = true;
          // to re-login
          ElMessageBox.confirm(
            '登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示',
            {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {

            setLogOut()

          }).catch(() => {

            isRelogin.show = false;

          });
        }
        else {
          //return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
          setLogOut()
        }

      } else if (res.ErrCode === '1') {
        //则ErrCode!=1和不等于上面得几个值外:跳过此统一错误拦截，即不在这里返回错误提示(留给接口自行处理错误提示)
        isRelogin.show = false;
        ElMessage({
          message: res.ErrMsg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(res.ErrMsg)
      }
      else {
        //此res错误直接让调用接口的提示，如果调用的接口没有定义提示则不提示
        return res
      }
    } else {
      //正确数据
      return res
    }
  },
  error => {
    let { message } = error
    if (message === 'Network Error') {
      message = '系统接口连接异常,请检查网络是否正常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时,请检查网络是否正常'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    } else {
      message = '请检查请求接口是否正常'
    }
    ElMessage({
      message: message,
      type: 'error',
      customClass: 'msgbox',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
//设置登出
function setLogOut() {
  //可能服务器上的缓存数据过期(重启等等)，此时的客户端的token那些数据还没过期，再退一次服务器数据
  isRelogin.show = false;
  store.dispatch('FedLogOut').then(() => {
    location.href = '/index';
  })
}

export default service
